import React, { useMemo } from 'react';

import './styles.css';

import { ScannerScreen } from '../ScannerScreen/ScannerScreen';
import { HomeScreen } from '../HomeScreen/HomeScreen';
import { RatePlanScreen } from '../RatePlanScreen/RatePlanScreen';
import { RouterProvider, useRouter } from '../../providers/Router/RouterProvider';
import { SettingsProvider } from '../../providers/Settings/SettingsProvider';
import { HubSpotEmbed } from '../HubSpot/HubSpotEmbed';
import { FormScreen } from '../FormScreen/FormScreen';
import { ActiveSessionScreen } from '../ActiveSessionScreen/ActiveSessionScreen';
import { CHARGER_IMAGE, PRICING_CHART_IMAGE } from '../../assets/images';

const IMAGES = [CHARGER_IMAGE, PRICING_CHART_IMAGE];

export const OrangeOptechDemo = ({
  hubspotPortalId,
  hubspotFormId
}) => {
  const settings = useMemo(() => {
    return {
      hubspotPortalId,
      hubspotFormId
    };
  }, [hubspotPortalId, hubspotFormId]);

  return (
    <SettingsProvider settings={settings}>
      <RouterProvider>
        <div className={`OrangeOptechDemo bg-backgroun`}>
          <AppRouter />
        </div>
        <ImagePreloader />
        <HubSpotEmbed />
      </RouterProvider>
    </SettingsProvider>
  );
}


const AppRouter = () => {
  const { currentScreen } = useRouter();

  switch (currentScreen) {
    case 'scanner':
      return <ScannerScreen />;
    case 'rateplan':
      return <RatePlanScreen />;
    case 'session':
      return <ActiveSessionScreen />;
    case 'form':
      return <FormScreen />;
    case 'home':
    default:
      return <HomeScreen />;
  }
};

const ImagePreloader = () => {
  return (
    <div style={{
      position: 'absolute',
      left: '-100px',
      top: '-100px',
      zIndex: -1,
      width: '1px',
      height: '1px',
      overflow: 'hidden',
      opacity: 0
    }}>
      {IMAGES?.map(
        (src, index) => 
          <img key={`${index}-${src}`} src={src} alt={''} width={1} height={1} />
      )}
    </div>
  );
}